"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const utils_1 = require("../../theme/utils");
const sizeMap = {
    s: {
        padding: '2px 8px',
        fontSize: '10px !important',
    },
    m: {
        padding: '5px 16px',
    },
};
const Component = styled_components_1.default.span(({ theme, variant, display, margin, size }) => (Object.assign(Object.assign(Object.assign({}, (theme.BADGE[variant] || {})), { display, margin: (0, utils_1.getMargin)({ theme, margin }) }), (size ? sizeMap[size] : {}))));
const Badge = (_a) => {
    var { display = 'inline-block', size = 'm' } = _a, props = __rest(_a, ["display", "size"]);
    return (0, jsx_runtime_1.jsx)(Component, Object.assign({ display: display, size: size }, props), void 0);
};
exports.Badge = Badge;
//# sourceMappingURL=Badge.js.map